export default __webpack_public_path__ + "static/mugmechanic-ba9a168513759b4fa02c0b2da2f6a258.svg";